import React, {useEffect}  from 'react'
import jQuery from "jquery";
import SearchBox from './SearchBox';
const ProductSearchContainer = (props) => {
    
  return (
    <React.Fragment>
        <div className="main-container navbar-fixed">
    {/* <!--Search HEADER  --> */}
    <section className="search-kv">
      <div className="search-kv__container prdouct-search">
        {/* <!-- Search Content  --> */}
        <div className="search-kv__contents">

          <h2 className="search-kv__title show-desktop">{props.title}</h2>
          <h2 className="search-kv__title show-mobile" data-font-size-mo="44">{props.title}</h2>
          <div className="search-kv__image">
            <div className="image image--main-loaded get-image-height">
              <img className="image__main responsive-img image--loaded show-desktop" src="/img/search/Home_KV_1440x500.jpg" alt="hero-banner"/>
            </div>
          </div>
        </div>
        {/* <!-- Search Box  --> */}
        <div className="search-kv__search-wrap">
          <SearchBox {...props}/>
        </div>

      </div>
    </section>
  </div>

    </React.Fragment>
  )
}

export default ProductSearchContainer